import { TUseSearchProductPageResponse } from "../../hooks/useSearchProductPage";
import ProdCard from "../box/ProdCard";
import { LvlPagi } from "./LvlPagi";

export const LvlPagiArea = (jj: TUseSearchProductPageResponse) => {
  return (
    <>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-6">
        {jj.dataProduct.length === 1 && <div className="dummy" />}
        {jj.dataProduct.map((p) => (
          <ProdCard className="max-w-full" key={p.id} {...p} />
        ))}
      </div>

      <LvlPagi
        totalPages={jj.totalPages}
        currentPage={jj.currentPage}
        handlePageChange={jj.handlePageChange}
      />
    </>
  );
};
